import React, { Fragment } from 'react';
export const text = {
  G: 'grams',
  KG: 'kilograms',
  ML: 'millilitres',
  L: 'LITRES'
};

const MeasurementTypeText = ({ type, capitalise }) => {
  const measure = text[type] || type;
  return <Fragment>{capitalise ? `${measure.charAt(0).toUpperCase()}${measure.slice(1)}` : measure}</Fragment>;
};

export default MeasurementTypeText;



// WEBPACK FOOTER //
// ./src/components/measurementTypeText/measurementTypeText.jsx